import { Component } from '@angular/core';

@Component({
  selector: 'app-cards8-examples-52',
  templateUrl: './cards8-examples-52.component.html'
})
export class Cards8Examples52Component {}
